module.exports = __webpack_public_path__ + "img/IMG_6737.b42f40f6.jpeg";